export default __webpack_public_path__ + "af91168c43fdeeb8751c5c1c7ef4b46a.jpeg";